// VARIANT COMPONENTS
export { ActionsDropdown } from './actions/ActionsDropdown';
export { ListDropdown } from './list/ListDropdown';
export { MultiselectDropdown } from './multiselect/MultiselectDropdown';


// PROPS
export interface BaseDropdownProps {
  styleClassNames: { [key: string]: string };
  variantName: string;
  anchorElement?: JSX.Element;
  arrowedItem?: ListOptionValue;
  className?: string;
  closeCallback?: () => void;
  closeDropdown?: boolean;
  disabled?: boolean;
  dropdownTransition?: DropdownTransitions;
  dropdownTransitionTime?: number;
  id?: string;
  isLoading?: boolean;
  isNestedDropdown?: boolean;
  keydownCallback?: (key: DropdownKeys, e: KeyboardEvent) => void;
  openDirection?: OpenDirections;
  openOnClick?: boolean;
  openOnHover?: boolean;
  overflowParentRef?: React.MutableRefObject<HTMLElement>;
  setIsDropdownOpen?: SetStateDispatch<boolean>;
  expandOnSpacebarKeypress?: boolean;
  useUlContainer?: boolean;
  userDevice?: UserDevices;
}

export type ActionsDropdownProps = Omit<BaseDropdownProps, 'styleClassNames' | 'variantName' | 'arrowedItem' | 'dropdownTransitionTime' | 'expandOnSpacebarKeypress' | 'isLoading' | 'keydownCallback' | 'overflowParentRef' | 'setIsDropdownOpen' | 'useUlContainer'>

interface ListDropdownPropsExtended extends BaseDropdownProps {
  anchorElementLabel?: string;
  onChange?: (listOption: ListOption, e?: React.SyntheticEvent) => void;
  onOpen?: () => void;
  options?: ListOption[];
  placeholder?: string;
  searchable?: boolean;
  value?: ListOption | ListOptionValue;
}
export type ListDropdownProps = Omit<ListDropdownPropsExtended, 'styleClassNames' | 'variantName' | 'arrowedItem' | 'closeCallback' | 'closeDropdown' | 'expandOnSpacebarKeypress' | 'keydownCallback' | 'setIsDropdownOpen' | 'useUlContainer'>

interface MultiselectDropdownPropsExtended extends BaseDropdownProps {
  anchorElementLabel?: string;
  onChange?: (updatedSelectedOptionValues: ListOptionValue[], isAdded?: boolean, updatedValue?: ListOptionValue) => void;
  onOpen?: () => void;
  options?: ListOption[];
  placeholder?: string;
  searchable?: boolean;
  values?: ListOption[] | ListOptionValue[];
}
export type MultiselectDropdownProps = Omit<MultiselectDropdownPropsExtended, 'styleClassNames' | 'variantName' | 'arrowedItem' | 'closeCallback' | 'closeDropdown' | 'expandOnSpacebarKeypress' | 'keydownCallback' | 'setIsDropdownOpen' | 'useUlContainer'>


// TYPES
export enum DropdownVariants {
  Actions = 'actions',
  List = 'list',
  Multiselect = 'multiselect',
}

// Variant TYPES - Actions
export enum ActionsOpenDirections {
  DownLeft = 'down-left',
  DownRight = 'down-right',
  UpLeft = 'up-left',
  UpRight = 'up-right',
}
export enum ActionsDropdownTransitions {
  FadeInTranslate = 'fade-in-translate',
  FadeIn = 'fade-in',
}

// Variant TYPES - List
export enum ListOpenDirections {
  Up = 'up',
  Down = 'down',
}
export enum ListDropdownTransitions {
  FadeIn = 'fade-in',
}
export type ListOptionValue = string | number | undefined;
export type ListOptionLabel = string | number;
export interface ListOption {
  label: ListOptionLabel;
  value: ListOptionValue;
  isDisabled?: boolean;
  type?: string;
}
export enum DropdownKeys {
  ArrowDown = 'ArrowDown',
  ArrowLeft = 'ArrowLeft',
  ArrowRight = 'ArrowRight',
  ArrowUp = 'ArrowUp',
  Backspace = 'Backspace', // on a mac: "delete"
  End = 'End', // on a mac: "fn" + "ArrowRight"
  Enter = 'Enter', // on a mac: "return"
  Home = 'Home', // on a mac: "fn" + "ArrowLeft"
  Spacebar = 'Spacebar',
  Space = ' ',
}


// Base TYPES
export type OpenDirections = ActionsOpenDirections | ListOpenDirections
export type DropdownTransitions = ActionsDropdownTransitions | ListDropdownTransitions
export enum OpenDirectionOverride {
  Up = 'up',
}
